import React, { useEffect, useState } from "react";
import { formatAmount } from "../../../utils/format.js";
import TranchePaymentDetailsModal from "./TranchePaymentDetailsModal.jsx";
import BankPaymentDetailsModal from "./BankPaymentDetailsModal.jsx";
import AddBankPaymentModal from "./AddBankPaymentModal.jsx";
import { axios_instance } from "../../../api/axios_instance.js";
import { useSelector } from "react-redux";
import {
  decryptRequest,
  encryptRequest,
} from "../../../utils/encryptdecryptrequest.js";

const PaymentSummary = ({ lead_id, caseDetails, fetchCaseData }) => {
  const initialState = {
    totalBankPayment: 0,
    totalReleasedPayment: 0,
    BankSummary: [],
    showTrancheDetailsModal: false,
    showBankDetailsModal: false,
    showAddBankPaymentModal: false,
  };

  //setting component state
  const [paymentSummaryState, setPaymentSummaryState] = useState(initialState);
  const detailsStore = useSelector((state) => state.details);

  let currentBalance, currentBalanceCls;
  if (!caseDetails.id) {
    currentBalance = "NA";
    currentBalanceCls = "";
  } else {
    currentBalance =
      caseDetails.current_balance !== ""
        ? formatAmount(caseDetails.current_balance)
        : "0";
    currentBalanceCls =
      caseDetails.current_balance !== "" && caseDetails.current_balance < 0
        ? "col-red"
        : "col-green";
  }

  const netDisAmt =
    caseDetails.net_disbursement_amount &&
    caseDetails.net_disbursement_amount !== ""
      ? caseDetails.net_disbursement_amount
      : caseDetails.lead_disbursed_amt;
  const pendingBankAmount = netDisAmt - paymentSummaryState.totalBankPayment;
  const pendingAmountCls = pendingBankAmount < 0 ? "col-green" : "col-red";

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!caseDetails) return;
        const reqData = encryptRequest({
          lead_id,
          dis_id: caseDetails.id ? caseDetails.id : 0,
          except_misc: "",
        });
        let paymentSummaryResult = await axios_instance({
          url: "/dts/getPaymentSums",
          method: "POST",
          data: { reqData },
        });
        paymentSummaryResult = decryptRequest(
          paymentSummaryResult.data.resData
        );

        setPaymentSummaryState((prevState) => ({
          ...prevState,
          totalBankPayment: parseInt(paymentSummaryResult.bank_payment_sum),
          totalReleasedPayment: paymentSummaryResult.sum_release_amount,
          BankSummary: paymentSummaryResult.summary,
        }));
      } catch (error) {}
    };

    fetchData();
  }, [lead_id, caseDetails]);

  const deletePayment = async (id, bank_payment_amount) => {
    const newBankPayment =
      paymentSummaryState.totalBankPayment - parseInt(bank_payment_amount);
    const BankSummary = paymentSummaryState.BankSummary.filter(
      (payment) => payment.bank_payment_id !== id
    );
    setPaymentSummaryState({
      ...paymentSummaryState,
      BankSummary,
      totalBankPayment: newBankPayment,
    });
    await fetchCaseData(true);
  };

  const addPayment = async (addData) => {
    const newBankPayment =
      paymentSummaryState.totalBankPayment +
      parseInt(addData.bank_payment_amount);
    setPaymentSummaryState({
      ...paymentSummaryState,
      BankSummary: [
        ...paymentSummaryState.BankSummary,
        {
          ...addData,
          bank_payment_id: addData.id,
          added_date: addData.bank_payment_date,
        },
      ],
      totalBankPayment: newBankPayment,
      showAddBankPaymentModal: false,
    });
    await fetchCaseData(true);
  };

  return (
    <span>
      <TranchePaymentDetailsModal
        closeTrancheDetailsModal={() =>
          setPaymentSummaryState({
            ...paymentSummaryState,
            showTrancheDetailsModal: false,
          })
        }
        caseDetails={caseDetails}
        showTrancheDetailsModal={paymentSummaryState.showTrancheDetailsModal}
      />

      <BankPaymentDetailsModal
        closeBankDetailsModal={() =>
          setPaymentSummaryState({
            ...paymentSummaryState,
            showBankDetailsModal: false,
          })
        }
        showBankDetailsModal={paymentSummaryState.showBankDetailsModal}
        BankSummary={paymentSummaryState.BankSummary}
        lead_id={lead_id}
        dis_id={caseDetails.id}
        sub_stage={parseInt(caseDetails.sub_stage)}
        current_balance={caseDetails.current_balance}
        deletePayment={deletePayment}
      />

      <AddBankPaymentModal
        closeAddBankPaymentModal={() =>
          setPaymentSummaryState({
            ...paymentSummaryState,
            showAddBankPaymentModal: false,
          })
        }
        dis_id={caseDetails.id}
        lead_id={lead_id}
        addPayment={addPayment}
        showAddBankPaymentModal={paymentSummaryState.showAddBankPaymentModal}
      />

      <div className="col-sm-4 border-dashed-r" id="payment_summary">
        <h3 className="panel-title">Payment Summary</h3>
        <table className="table">
          <tbody>
            <tr>
              <td>
                <div className="caseTxt">Received Amount</div>
                <div className="casedetailTxt">
                  <span className="fa fa-inr"></span>
                  {formatAmount(paymentSummaryState.totalBankPayment)}
                  {paymentSummaryState.totalBankPayment > 0 && (
                    <button
                      className="ic_info bpdetails"
                      title="Received Amount"
                      onClick={(e) => {
                        setPaymentSummaryState({
                          ...paymentSummaryState,
                          showBankDetailsModal: true,
                        });
                        e.stopPropagation();
                      }}
                      disabled={detailsStore.formLoading}
                    >
                      <img
                        src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                        alt=""
                      />
                    </button>
                  )}
                </div>
              </td>
              <td>
                <div className="caseTxt">Released Amount</div>
                <div className="casedetailTxt">
                  <span className="">
                    {formatAmount(paymentSummaryState.totalReleasedPayment)}
                  </span>
                  {paymentSummaryState.totalReleasedPayment > 0 && (
                    <button
                      className="ic_info tpdetails"
                      title="Released Amount"
                      onClick={(e) => {
                        setPaymentSummaryState({
                          ...paymentSummaryState,
                          showTrancheDetailsModal: true,
                        });
                        e.stopPropagation();
                      }}
                      disabled={detailsStore.formLoading}
                    >
                      <img
                        src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                        alt=""
                        className="ic_info"
                      />
                    </button>
                  )}
                </div>
              </td>
              <td>
                <div className="caseTxt">Ledger Balance</div>
                <div className="casedetailTxt">
                  <strong>
                    <span className={`${currentBalanceCls}`}>
                      {currentBalance && currentBalance !== "NA" ? (
                        <span className="fa fa-inr"></span>
                      ) : (
                        <></>
                      )}
                      {currentBalance}
                    </span>
                  </strong>
                </div>
              </td>
            </tr>
            <tr className="border-top">
              <td>
                <div className="caseTxt">Net Disbursed</div>
                <div className="casedetailTxt">
                  <span className="fa fa-inr"></span>
                  {formatAmount(netDisAmt)}
                </div>
              </td>
              <td>
                <div className="caseTxt">Pending Amount</div>
                <div className="casedetailTxt">
                  <span className={`fa fa-inr ${pendingAmountCls}`}>
                    {formatAmount(pendingBankAmount)}
                  </span>
                </div>
              </td>
              <td>
                <button
                  name="addpayment"
                  data-toggle="modal"
                  data-target="#bank-payment-modal"
                  className="mrg-T10 btn btn-default btn-green"
                  onClick={(e) => {
                    setPaymentSummaryState({
                      ...paymentSummaryState,
                      showAddBankPaymentModal: true,
                    });
                    e.stopPropagation();
                  }}
                  disabled={detailsStore.formLoading}
                >
                  Add
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </span>
  );
};

export default PaymentSummary;
